<template>
  <div id="app">
    <div v-if="!isFirst && routeObj && routeObj.path !== '/jhkGuide'" class="hookbox"></div>
      <el-container v-if="!nopermission && !isOther && routeObj.path !== '/jhkGuide'">
        <!-- 后台管理-帮助中心-使用教程的paths为0，不显示头部 -->
        <el-header height="60px" v-if="!isLogin">
          <page-header :paths="paths"></page-header>
        </el-header>
        <el-container>
          <el-aside v-show="paths.length > 1 && !isLogin" class="aside" style="width: 170px">
            <left-select :paths="paths"></left-select>
          </el-aside>
          <el-main>
            <breadpath v-show="paths.length > 1" :paths="paths.map((i) => i.tittle)"></breadpath>
            <router-view :key="$route.path"></router-view>
          </el-main>
        </el-container>
      </el-container>
      <div v-else-if="routeObj && (routeObj.path == '/jhkGuide' || routeObj.path == '/industryPreview')">
        <router-view ></router-view>
      </div>
    <div v-else-if="isOther && routeObj && routeObj.path !== '/jhkGuide'">
      <page-header-industry></page-header-industry>
      <router-view ></router-view>
    </div>
    
    <div v-else class="have-no-permission">无权限访问</div>
  </div>
</template>

<script>
import { login } from "@/api/login";
import { getSellerInfo } from "@/api/sellerController";
import "./utils/test";
import axios from "axios";
// import $ from "jquery";
// import { queryMenu } from "@/api/public";
import Vue from "vue";
import { mapMutations } from "vuex";
import { checkSellerOwnRorNot } from "@/api/public";
import pageHeader from "@/components/page-header"; //总的头部
import leftSelect from "@/components/left-select"; //总的侧边栏
import breadpath from "@/components/bread-path"; //总的面包屑
import pageHeaderIndustry from "@/components/page-header-industry"; //总的头部
export default {
  components: {
    pageHeader,
    leftSelect,
    breadpath,
    pageHeaderIndustry
  },
  data() {
    return {
      paths: [],
      isLogin: false,
      routeVersion1: [],
      routeVersion2: [],
      routeObj: null,
      nopermission: false, // 判断权限
      isOther:false,
      isFirst:false,
    };
  },
  computed: {
    headItem() {
      return this.$store.state.route; //存放在router里边的路径
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    shopTitle() {
      // 店铺名称
      return this.$store.getters.loginUserInfo.shopTitle;
    },
    // isOther(){// 是否为另外弹窗（行业专区）
    //   console.log(this.$route,'route')
    //   if(!this.$route.meta.isOther){
    //     return false
    //   }else{
    //     return true
    //   }
    // }, 
  },
  watch: {
    headItem: {
      deep: true,
      immediate: true,
      handler: function(nval, oval) {
        console.log(1111111, this.routeObj)
        if (this.routeObj && nval && nval.length > 0) {
          //watch中需要具体执行的方法
          if (this.routeObj.path === "/login") {
            this.isLogin = true;
            return;
          }
          this.isLogin = false;
          var path = location.pathname.replace("/yusms", "");

          let route = path.split("/"), //路径里边有/,所以要截取掉
            name = [];
          let index1 = this.headItem.map((i) => i.path).indexOf("/" + route[1]); //取出所对应的索引
          index1 !== -1 &&
            name.push({
              tittle: this.headItem[index1].tittle,
              index: index1,
              path: this.headItem[index1].path,
            });
          if (this.headItem[index1] && this.headItem[index1].children && this.headItem[index1].children.length > 0) {
            // debugger
            //第一层数据的判断
            let index2 = this.headItem[index1].children.map((i) => i.path).indexOf(route[2]); //取出第二层索引
            index2 !== -1 &&
              name.push({
                tittle: this.headItem[index1].children[index2].tittle,
                index: index2,
                path: this.headItem[index1].children[index2].path,
              });
            if (
              this.headItem[index1].children[index2] &&
              this.headItem[index1].children[index2].children &&
              this.headItem[index1].children[index2].children.length > 0
            ) {
              //子层数据判断
              let index3 = this.headItem[index1].children[index2].children.map((i) => i.path).indexOf(route[3]);
              index3 !== -1 &&
                name.push({
                  tittle: this.headItem[index1].children[index2].children[index3].tittle,
                  index: index3,
                  path: this.headItem[index1].children[index2].children[index3].path,
                });
            }
          }
          this.paths = name;
          this.$store.state.pathNow = name;
        }
      },
    },
    $route: {
      //监听路由信息对象
      deep: true, //监听的数据深度,一般用来监听对象中某个属性的变化
      immediate: true, //在选项参数中指定true将立即以表达式的当前值触发回调
      handler: function(newval, oldval) {
        console.log('newval:', newval)
        
        // 无权限判断
        if(newval.path === "/nopermission") {
          this.nopermission = true;
          this.isFirst = true;
          return
        } else {
          this.nopermission = false
        }
        this.routeObj = newval;
        //watch中需要具体执行的方法
        if (newval.path === "/login" || newval.path === "/redirection") {
          this.isLogin = true;
          this.isFirst = true;
          return;
        }
        if (newval.path === "/industryStrategy" || newval.path === "/industrySolution" || newval.path === "/industryCrowd" || newval.path === "/industryPreview") {
          this.isOther = true;
          this.isFirst = true;
        }else{
          console.log('newval.path:',newval.path)
          this.isOther = false;
         
        }

        if (newval.path !== '/') {
          this.isFirst = true
        }
        this.isLogin = false;
        var path = location.pathname.replace("/yusms", "");

        let route = path.split("/"), //路径里边有/,所以要截取掉
          name = [];
        let index1 = this.headItem.map((i) => i.path).indexOf("/" + route[1]); //取出所对应的索引
        index1 !== -1 &&
          name.push({
            tittle: this.headItem[index1].tittle,
            index: index1,
            path: this.headItem[index1].path,
          });
        if (this.headItem[index1] && this.headItem[index1].children && this.headItem[index1].children.length > 0) {
          // debugger
          //第一层数据的判断
          let index2 = this.headItem[index1].children.map((i) => i.path).indexOf(route[2]); //取出第二层索引
          index2 !== -1 &&
            name.push({
              tittle: this.headItem[index1].children[index2].tittle,
              index: index2,
              path: this.headItem[index1].children[index2].path,
            });
          if (
            this.headItem[index1].children[index2] &&
            this.headItem[index1].children[index2].children &&
            this.headItem[index1].children[index2].children.length > 0
          ) {
            //子层数据判断
            let index3 = this.headItem[index1].children[index2].children.map((i) => i.path).indexOf(route[3]);
            index3 !== -1 &&
              name.push({
                tittle: this.headItem[index1].children[index2].children[index3].tittle,
                index: index3,
                path: this.headItem[index1].children[index2].children[index3].path,
              });
          }
        }
        this.paths = name;
        this.$store.state.pathNow = name;
        
      },
    },
    // shopTitle: {
    //   deep: true,
    //   immediate: true,
    //   handler(newVal, oldVal) {
    // console.log('this.shopTitle', this.shopTitle)
    // if (this.shopTitle == '服务市场测试店铺' || this.shopTitle == '初缘旗舰店' || this.shopTitle == '361度逸航专卖店') {
    //   this.$store.state.route = this.routeVersion1;
    // }else {
    //   this.$store.state.route = this.routeVersion2;
    // }
    //   }
    // }
  },
  created() {
    sessionStorage.setItem("showNotice", "true");
    sessionStorage.setItem("isPopVisiv", "true");
 
    // window.reload()
    // console.log('111111');
    // window.onload = () => {
    //   window.reload();
    // }
    // if (window.performance.navigation.type == 1) {
    //   console.log("页面被刷新");
    // } else {
    //   // 系统公告
    //   sessionStorage.setItem("visibleXitou", "true");
    // }
    // t弹窗
    // this.openWin();
  },
  mounted: function() {
    Vue.prototype.$checkSellerOwnRorNot = checkSellerOwnRorNot;
    console.log(this.$route.path)
    // let otherArr = ['industryStrategy','/industrySolution','/industryCrowd']
    // console.log('route',this.$route,otherArr.find(this.$route.path))
    // if(otherArr.includes(this.$route.path)){
    //   this.isOther = false
    // }else{
    //   this.isOther = true
    // }
    this.$store.state.topPx = document.getElementsByClassName("el-header")[0].clientHeight;
    // this.routeVersion1 = [
    //   {
    //     tittle: "首页",
    //     path: "/home",
    //     children: [],
    //   },
    //   {
    //     tittle: "客户管理",
    //     path: "/manage",
    //     children: [
    //       {
    //         tittle: "会员管理",
    //         path: "manage",
    //         children: [
    //           {
    //             tittle: "会员列表",
    //             path: "focusShop",
    //           },
    //           {
    //             tittle: "会员分组",
    //             path: "focus_merchandise",
    //           },
    //           {
    //             tittle: "会员分群",
    //             path: "grouping",
    //           },
    //           {
    //             tittle: "黑名单列表",
    //             path: "share_polite",
    //           },
    //         ],
    //         icon: require("./assets/images/icon/nav_kehuguanli.png"),
    //       },
    //       {
    //         tittle: "标签管理",
    //         path: "labelManage",
    //         children: [
    //           {
    //             tittle: "标签管理",
    //             path: "labelManage",
    //           },
    //           {
    //             tittle: "自动化打标",
    //             path: "automatic_marking",
    //           },
    //         ],
    //         icon: require("./assets/images/icon/nav_biaoqianguanli.png"),
    //       },
    //     ],
    //   },
    //   {
    //     tittle: "订单关怀",
    //     path: "/orderCare",
    //     children: [
    //       {
    //         tittle: "下单催付",
    //         path: "orderCare",
    //         children: [
    //           {
    //             tittle: "下单关怀（货到）",
    //             path: "goodsOrderCare",
    //           },
    //           {
    //             tittle: "常规催付",
    //             path: "expediting",
    //           },
    //           {
    //             tittle: "二次催付",
    //             path: "twiceExpediting",
    //           },

    //           {
    //             tittle: "预售尾款催付",
    //             path: "presaleExpediting",
    //           },
    //         ],
    //         icon: require("./assets/images/icon/nav_huiyuanguanhuai.png"),
    //       },
    //       {
    //         tittle: "付款关怀",
    //         path: "payReminder",
    //         children: [
    //           {
    //             tittle: "付款关怀",
    //             path: "payReminder",
    //           },
    //         ],
    //         icon: require("./assets/images/icon/nav_fukuanguanhuai.png"),
    //       },
    //       {
    //         tittle: "物流提醒",
    //         path: "transreMind",
    //         children: [
    //           {
    //             tittle: "取消提醒",
    //             path: "cancelMind",
    //           },
    //           {
    //             tittle: "发货提醒",
    //             path: "sendreMind",
    //           },
    //           {
    //             tittle: "迟发提醒",
    //             path: "delayMind",
    //           },
    //           {
    //             tittle: "派件提醒",
    //             path: "delivereMind",
    //           },
    //           {
    //             tittle: "签收提醒",
    //             path: "recvreMind",
    //           },
    //           {
    //             tittle: "退货提醒",
    //             path: "goodsBackMind",
    //           },
    //         ],
    //         icon: require("./assets/images/icon/nav_wuliutixing.png"),
    //       },
    //       {
    //         tittle: "完成提醒",
    //         path: "moneyBack",
    //         children: [
    //           {
    //             tittle: "完成提醒",
    //             path: "moneyBack",
    //           },
    //         ],
    //         icon: require("./assets/images/icon/nav_huikuanguanhuai.png"),
    //       },
    //       {
    //         tittle: "评价关怀",
    //         path: "comtCare",
    //         children: [
    //           {
    //             tittle: "自动催评",
    //             path: "autoEvaluation",
    //           },
    //           {
    //             tittle: "好评感谢",
    //             path: "thankEvaluation",
    //           },
    //           {
    //             tittle: "中差评安抚",
    //             path: "poorEvaluation",
    //           },
    //           {
    //             tittle: "好评感谢（自营）",
    //             path: "thankEvaluationOfficial",
    //           },
    //           {
    //             tittle: "中差评安抚（自营）",
    //             path: "poorEvaluationOfficial",
    //           },
    //         ],
    //         icon: require("./assets/images/icon/nav_pingjiaguanhuai.png"),
    //       },
    //       {
    //         tittle: "退款关怀",
    //         path: "refunCare",
    //         children: [
    //           {
    //             tittle: "申请退款",
    //             path: "apply",
    //           },
    //           {
    //             tittle: "同意退款",
    //             path: "agree",
    //           },
    //           {
    //             tittle: "拒绝退款",
    //             path: "deny",
    //           },
    //           {
    //             tittle: "退款成功",
    //             path: "suces",
    //           },
    //         ],
    //         icon: require("./assets/images/icon/nav_tuikuanguanhuai.png"),
    //       },
    //     ],
    //   },
    //   {
    //     tittle: "客户营销",
    //     path: "/marketing",
    //     children: [
    //       {
    //         tittle: "精准营销",
    //         path: "marketing",
    //         children: [
    //           {
    //             tittle: "会员分群",
    //             path: "grouping",
    //           },
    //           {
    //             tittle: "精准营销",
    //             path: "accurate_market",
    //           },
    //           {
    //             tittle: "会员发送",
    //             path: "member_send",
    //           },
    //           {
    //             tittle: "订单发送",
    //             path: "order_sent",
    //           },
    //           {
    //             tittle: "指定号码发送",
    //             path: "designated_send",
    //           },
    //           {
    //             tittle: "变量短信发送",
    //             path: "variables-send",
    //           },
    //           {
    //             tittle: "营销汇总分析",
    //             path: "summary-analysis",
    //           },
    //         ],
    //         icon: require("./assets/images/icon/nav_jingzhunyingxiao.png"),
    //       },
    //       {
    //         tittle: "自动化营销",
    //         path: "auto_marketing",
    //         children: [
    //           {
    //             tittle: "商品复购",
    //             path: "goods_repurchase",
    //           },
    //           {
    //             tittle: "首购有礼",
    //             path: "first_purchase",
    //           },
    //           {
    //             tittle: "复购有礼",
    //             path: "repurchase",
    //           },
    //           {
    //             tittle: "休眠提醒",
    //             path: "sleep_remind",
    //           },
    //           {
    //             tittle: "满月礼",
    //             path: "fullmonthgift",
    //           },
    //           {
    //             tittle: "百日礼",
    //             path: "hundred_day_gift",
    //           },
    //           {
    //             tittle: "周年庆",
    //             path: "anniversary",
    //           },
    //           {
    //             tittle: "会员账单",
    //             path: "memberbill",
    //           },

    //           {
    //             tittle: "活动码",
    //             path: "activity",
    //           },
    //         ],
    //         icon: require("./assets/images/icon/nav_zidonghuaxiaoshou.png"),
    //       },
    // {
    //   tittle: "自动化营销（官方）",
    //   path: "auto_marketing_official",
    //   children: [
    //     {
    //       tittle: "首购有礼",
    //       path: "first_purchase_official",
    //     },
    //     {
    //       tittle: "复购提醒",
    //       path: "reminder_purchase_official",
    //     },
    //     {
    //       tittle: "客户流失召唤",
    //       path: "call_customer_churn",
    //     },
    //   ],
    //   icon: require("./assets/images/icon/nav_zidonghuaxiaoshou.png"),
    // },
    //   ],
    // },
    // {
    //   tittle: "售后中心",
    //   path: "/serviceCenter",
    //   children: [
    //     {
    //       tittle: "评价管理",
    //       path: "evaluate",
    //       children: [
    //         {
    //           tittle: "手动催评",
    //           path: "manualurg",
    //         },
    //         {
    //           tittle: "手动回评",
    //           path: "manualReply",
    //         },
    //         {
    //           tittle: "自动回评",
    //           path: "autoassess",
    //           desc:
    //             "多个评价策略可供选择，自动给买家评价，全面保障店铺DSR评分",
    //         },
    //       ],
    //       icon: require("./assets/images/serviceCenter/nav_pjzx.png"),
    //     },
    //     {
    //       tittle: "评价分析",
    //       path: "asesAnalysis",
    //       children: [
    //         {
    //           tittle: "商品评价分析",
    //           path: "allGoodsAssess",
    //         },
    //         {
    //           tittle: "删评监控",
    //           path: "delMonitor",
    //         },
    //       ],
    //       icon: require("./assets/images/serviceCenter/nav_pjfx.png"),
    //     },
    //     {
    //       tittle: "退款中心",
    //       path: "refundCenter",
    //       children: [
    //         {
    //           tittle: "手动审核退款",
    //           path: "manualRefund",
    //         },
    //         {
    //           tittle: "自动审核退款",
    //           path: "autoRefund",
    //         },
    //       ],
    //       icon: require("./assets/images/serviceCenter/nav_tkzx.png"),
    //     },
    //     {
    //       tittle: "店铺预警",
    //       path: "shopWarning",
    //       children: [
    //         {
    //           tittle: "评价预警",
    //           path: "commentWarning",
    //         },
    //         {
    //           tittle: "退款预警",
    //           path: "refundWarning",
    //         },
    //       ],
    //       icon: require("./assets/images/serviceCenter/nav_dpyj.png"),
    //     },
    //   ],
    // },
    // {
    //   tittle: "忠诚度管理",
    //   path: "/integralCenter",
    //   children: [
    //     {
    //       tittle: "忠诚度管理",
    //       path: "integralCenter",
    //       children: [
    //         {
    //           tittle: "互动会员",
    //           path: "mutualMember",
    //         },
    //         {
    //           tittle: "会员等级/积分设置",
    //           path: "memberLevel",
    //         },
    //         {
    //           tittle: "会员权益",
    //           path: "memberPower",
    //         },
    //       ],
    //       icon: require("./assets/images/icon/nav_zhongchengdushezhi.png"),
    //     },
    //     {
    //       tittle: "积分任务",
    //       path: "integralTask",
    //       icon: require("./assets/images/icon/nav_jifenrenwu.png"),
    //     },
    //     {
    //       tittle: "积分乐园",
    //       path: "integralEden",
    //       icon: require("./assets/images/icon/nav_jifenleyuan.png"),
    //     },
    //     {
    //       tittle: "积分商城",
    //       path: "integralMall",
    //       icon: require("./assets/images/icon/nav_jifenshangcheng.png"),
    //     },
    //     {
    //       tittle: "店铺装修",
    //       path: "shopDecoration",
    //       icon: require("./assets/images/icon/nav_decoration.png"),
    //     },
    //     {
    //       tittle: "奖品中心",
    //       path: "prizeCenter",
    //       icon: require("./assets/images/icon/nav_prize.png"),
    //       children: [
    //         {
    //           tittle: "优惠券管理",
    //           path: "coupon_management",
    //         },
    //         {
    //           tittle: "资产项管理",
    //           path: "asset_management",
    //         },
    //       ],
    //     },
    //     {
    //       tittle: "数据分析",
    //       path: "dataAnalysis",
    //       children: [
    //         {
    //           tittle: "活动数据",
    //           path: "flow_analysis",
    //         },
    //         {
    //           tittle: "奖品统计",
    //           path: "prize_statistics",
    //         },
    //       ],
    //       icon: require("./assets/images/icon/nav_shujufenxi.png"),
    //     },
    //   ],
    // },
    // {
    //   tittle: "忠诚度管理",
    //   path: "/integralCenter",
    //   children: [
    //     {
    //       tittle: "忠诚度管理",
    //       path: "integralCenter",
    //       children: [
    //         {
    //           tittle: "互动会员",
    //           path: "mutualMember",
    //         },
    //         {
    //           tittle: "会员等级/积分设置",
    //           path: "memberLevel",
    //         },
    //         {
    //           tittle: "会员权益",
    //           path: "memberPower",
    //         },
    //       ],
    //       icon: require("./assets/images/icon/nav_zhongchengdushezhi.png"),
    //     },
    //     {
    //       tittle: "积分任务",
    //       path: "integralTask",
    //       icon: require("./assets/images/icon/nav_jifenrenwu.png"),
    //     },
    //     {
    //       tittle: "积分乐园",
    //       path: "integralEden",
    //       icon: require("./assets/images/icon/nav_jifenleyuan.png"),
    //     },
    //     {
    //       tittle: "积分商城",
    //       path: "integralMall",
    //       icon: require("./assets/images/icon/nav_jifenshangcheng.png"),
    //     },
    //     {
    //       tittle: "店铺装修",
    //       path: "shopDecoration",
    //       icon: require("./assets/images/icon/nav_decoration.png"),
    //     },
    //     {
    //       tittle: "奖品中心",
    //       path: "prizeCenter",
    //       icon: require("./assets/images/icon/nav_prize.png"),
    //       children: [
    //         {
    //           tittle: "优惠券管理",
    //           path: "coupon_management",
    //         },
    //         {
    //           tittle: "资产项管理",
    //           path: "asset_management",
    //         },
    //       ],
    //     },
    //     {
    //       tittle: "数据分析",
    //       path: "dataAnalysis",
    //       children: [
    //         {
    //           tittle: "活动数据",
    //           path: "flow_analysis",
    //         },
    //         {
    //           tittle: "奖品统计",
    //           path: "prize_statistics",
    //         },
    //       ],
    //       icon: require("./assets/images/icon/nav_shujufenxi.png"),
    //     },
    //   ],
    // },

    //   {
    //     tittle: "数据分析",
    //     path: "/analysis",
    //     children: [
    //       {
    //         tittle: "客户分析(自营)",
    //         path: "customerAnalysisSelfSupport",
    //         children: [
    //           {
    //             tittle: "客户画像",
    //             path: "customerAnalysisSelfSupport",
    //           },
    //           {
    //             tittle: "营销洞察",
    //             path: "marketing_insight",
    //           },
    //         ],
    //         icon: require("./assets/images/icon/nav_kehufenxi.png"),
    //       },
    //       {
    //         tittle: "客户分析",
    //         path: "customerAnalysis",
    //         children: [
    //           {
    //             tittle: "会员等级",
    //             path: "people_level",
    //           },
    //           // {
    //           //   tittle: "营销洞察",
    //           //   path: "marketing_insight",
    //           // },
    //           {
    //             tittle: "地域分析",
    //             path: "regional_analysis",
    //           },
    //           {
    //             tittle: "金额分析",
    //             path: "amount_analysis",
    //           },
    //           {
    //             tittle: "月度报表",
    //             path: "monthly_report",
    //           },
    //         ],
    //         icon: require("./assets/images/icon/nav_kehufenxi.png"),
    //       },
    //       {
    //         tittle: "RFM分析",
    //         path: "rfmAnalysis",
    //         children: [
    //           {
    //             tittle: "RFM标准分析",
    //             path: "RFM_standard_analysis",
    //           },
    //           {
    //             tittle: "RFM自定义分析",
    //             path: "RFM_custom_analysis",
    //           },
    //         ],
    //         icon: require("./assets/images/icon/nav_RFMfenxi.png"),
    //       },
    //       {
    //         tittle: "商品分析",
    //         path: "goods",
    //         children: [
    //           {
    //             tittle: "商品回购周期分析",
    //             path: "goods_repurchase",
    //           },
    //           {
    //             tittle: "商品销售连带分析",
    //             path: "goods_combine",
    //           },
    //         ],
    //         icon: require("./assets/images/icon/nav_shangpingfenxi.png"),
    //       },
    //     ],
    //   },
    //   {
    //     tittle: "后台管理",
    //     path: "/backstage",
    //     children: [
    //       {
    //         tittle: "短信管理",
    //         path: "backstage",
    //         children: [
    //           {
    //             tittle: "短信充值",
    //             path: "sms_management",
    //           },
    //           {
    //             tittle: "短信账单",
    //             path: "sms_bill",
    //           },
    //           {
    //             tittle: "短信记录",
    //             path: "sms_reply_record",
    //           },
    //           {
    //             tittle: "短信模板",
    //             path: "sms_module",
    //           },
    //         ],
    //         icon: require("./assets/images/icon/nav_duanxinguanli.png"),
    //       },
    //       {
    //         tittle: "签名管理",
    //         path: "signature_management",
    //         children: [
    //           {
    //             tittle: "签名报备",
    //             path: "signature_management",
    //           },
    //           {
    //             tittle: "签名报备（官方）",
    //             path: "signature_report_official",
    //           },
    //         ],
    //         icon: require("./assets/images/icon/nav_dianpuqianming.png"),
    //       },
    //       {
    //         tittle: "系统设置",
    //         path: "account",
    //         children: [
    //           {
    //             tittle: "账户设置",
    //             path: "account",
    //           },
    //           {
    //             tittle: "多店铺绑定",
    //             path: "store_binding",
    //           },
    //         ],
    //         icon: require("./assets/images/icon/nav_xitongshezhi.png"),
    //       },
    //       {
    //         tittle: "邀请好友赚积分",
    //         path: "invite_friends",
    //         icon: require("./assets/images/icon/nav_xitongshezhi.png"),
    //       },
    //     ],
    //   },
    // ];

    // this.routeVersion2 = JSON.parse(JSON.stringify(this.routeVersion1))
    // this.routeVersion2.forEach((item, index) => {
    //   if (item.tittle == '忠诚度管理') {
    //     this.routeVersion2.splice(index, 1)
    //   }
    // })
    //   this.$store.state.route = this.routeVersion1;
  },
  methods: {
    ...mapMutations({
      editUserInfo: "LOGINUSERINFO",
    }),
    setCookie(name, value, expire) {
      window.document.cookie = name + "=" + escape(value) + (expire == null ? "" : "; expires=" + expire.toGMTString());
    },
    getCookie(Name) {
      var search = Name + "=";
      if (window.document.cookie.length > 0) {
        // if there are any cookies
        let offset = window.document.cookie.indexOf(search);
        if (offset != -1) {
          // if cookie exists
          offset += search.length;
          // set index of beginning of value
          let end = window.document.cookie.indexOf(";", offset);
          // set index of end of cookie value
          if (end == -1) end = window.document.cookie.length;
          return unescape(window.document.cookie.substring(offset, end));
        }
      }
      return null;
    },
    register(name) {
      var today = new Date();
      var expires = new Date();
      // console.log(expires.setTime(today.getTime()));
      expires.setTime(today.getTime() + 1000 * 60 * 60 * 24);
      // expires.setTime(today.getTime() + 1000 * 60 * 5);
      this.setCookie("ItDoor3", name, expires);
    },
    openWin() {
      var c = this.getCookie("ItDoor3");
      if (c != null) {
        sessionStorage.removeItem("visibleXitou");
      } else {
        this.register("xiaolin");
        sessionStorage.setItem("visibleXitou", "true");
      }
    },
  },
};
</script>

<style lang="scss">
.have-no-permission {
  color: #666;
  font-size: 14px;
  padding: 20px;
}
/deep/ .swiper-pagination-bullet-active {
  background-color: #fe4d45 !important;
  width: 8px;
  height: 8px;
}
.el-popover {
  padding: 12px !important;
}
body {
  margin: 0;
  font-size: 14px;
}
/deep/ .el-cascader__dropdown {
  z-index: 3333 !important;
}
.el-date-picker__time-header .el-date-picker__editor-wrap .el-time-panel {
  left: -48px !important;
}

#app {
  font-family: "Microsoft YaHei", "Arial", "Helvetica", "sans-serif", "font_family" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  background-color: #f5f8fa;
  font-size: 14px;
  margin-left: 0px;
}
#app .el-header {
  padding: 0;
}
#app .aside {
  padding: 0;
  width: 170px !important;
  background: #fff;
}
#app .el-main {
  padding: 0;
  margin: 0;
}
#app /deep/.v-modal {
  z-index: 2888 !important;
}
</style>
<style  lang="scss" scoped>
.hookbox{
  position: absolute;
  top: 0;
  height: 70px;
  width: 100%;
  background: #f5f8fa;
  z-index: 999;
}
</style>
